module.exports = __webpack_public_path__ + "1.0/img/biaoge-pc.4dae7f73.png";